import { initFilterGlobals } from './prime-filter-utils.js';
import { initScheduleFilters } from './prime-schedule-filters.js';
import { initStatsFilters } from './prime-stats-filters.js';

/**
 * Entry point for all filter systems.
 * Globals are initialised first so both filter modules can rely on them.
 */
export function initPrimeFilters() {
    initFilterGlobals();
    initScheduleFilters();
    initStatsFilters();
}



// WEBPACK FOOTER //
// ./scripts/routes/common/prime-filters.js